"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.token = void 0;
/**
 *
 * @param {ICredentials} creds The token from server
 * @returns {string} A signed JWT.
 */
function token(creds) {
    if (creds.token) {
        return creds.token;
    }
    return "";
}
exports.token = token;
